<template>
  <div id="orderMenuCheckout">
    <Checkout />
  </div>
</template>

<script>
import Checkout from "@/components/page-components/Checkout/Checkout.vue";

export default {
  components: {
    Checkout,
  },
};
</script>

<style scoped lang="scss">
@import '@/css/customizer';
</style>
